import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import moment from "moment";
import { interval, Subscription } from "rxjs";

@Component({
  selector: "evrideo-calendar-expandable-progress-bar",
  templateUrl: "./calendar-expandable-progress-bar.component.html",
  styleUrls: ["./calendar-expandable-progress-bar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandableProgressBarComponent
  implements OnInit, OnDestroy
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  @Input() eventData;
  intervalSub: Subscription;
  backgroundStyle: { background: string };

  ngOnInit(): void {
    this.setBackgroundStyle();
    this.intervalSub = interval(1000).subscribe(() => {
      this.setBackgroundStyle();
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.intervalSub?.unsubscribe();
  }

  setBackgroundStyle(): void {
    const currentTime = moment().unix();
    const startTime = moment(this.eventData?.startTime).unix();
    const duration = moment.duration(this.eventData?.duration).asSeconds();
    const progressPercentage = ((currentTime - startTime) / duration) * 100;
    const barColor = progressPercentage < 100 ? "#AEE5FF" : "#C2CCDB";
    this.backgroundStyle = {
      background: `linear-gradient(90deg, ${barColor} ${progressPercentage}%, #E2E8F1 0%)`,
    };
    if (progressPercentage >= 100) {
      this.intervalSub?.unsubscribe();
    }
  }
}
